module.exports = __webpack_public_path__ + "static/Vazir-Medium-5ac0669e0d4e3619b6584bc21fda264c.eot";